module.exports = __webpack_public_path__ + "img/video_elektronik_imza.1eef42f3.png";